import { useSelector, useDispatch } from "react-redux";
import { omit as _omit, get as _get } from "lodash";
// components mui
import { Alert, Box, Button, Modal, Typography } from "@mui/material";

// Actions
import { setModalData, setModal } from "../../../redux/actions/modals";
import { setCustomTokenData } from "../../../redux/actions/tokens";

// Local Storage
import LS from "../../../helpers/storage";

// components
import TokenLogo from "../../TokenLogo";
import ModalHeader from "./../ModalHeader";

const ModalImportToken = () => {
  // hooks
  const dispatch = useDispatch();

  // selectors
  const currentModal = useSelector((state) => state.modals.modal);
  const currentModalData = useSelector((state) => state.modals.data);
  const custom_tokens = useSelector((state) => state.tokens.custom_tokens);

  // variables
  let token = _get(currentModalData, "token", null);

  // functions
  const closeModal = () => {
    dispatch(setModal(null));
    dispatch(setModalData(null));
  };
  const backModal = () => {
    dispatch(setModal("ManageToken"));
    dispatch(setModalData(_omit(currentModalData, ["token"])));
  };
  const importToken = () => {
    if (!custom_tokens || !custom_tokens.find((key) => key.address === token.address)) {
      let newStorageArray = custom_tokens ?? [];
      newStorageArray = [...newStorageArray, token];
      // save to localStorage
      LS.custom_tokens(newStorageArray);
      dispatch(setCustomTokenData(newStorageArray));
    }
    dispatch(setModal("ManageToken"));
    dispatch(setModalData(_omit(currentModalData, ["token"])));
  };

  return (
    <Modal open={currentModal === "ImportToken"} onClose={closeModal} sx={{ display: "flex", p: 2 }}>
      <Box sx={{ width: "100%", maxWidth: 420, m: "auto", maxHeight: "calc(100vh - 32px)", overflowY: "auto" }}>
        <ModalHeader title={"Import token"} closeFunction={closeModal} backArrow={backModal} />
        {token ? (
          <Box sx={{ px: 2.5, pb: 2.5, display: "flex", flexDirection: "column", gap: 2 }}>
            <Box
              sx={{
                p: 2,
                borderRadius: "14px",
                bgcolor: "background.light",
                display: "flex",
                alignItems: "center",
                gap: 1.5,
              }}
            >
              <TokenLogo token={token} size={44} />
              <Box sx={{ minWidth: 0 }}>
                <Typography sx={{ fontWeight: 600 }} noWrap>
                  {token.name}{" "}
                  <Box component="span" sx={{ color: "text.secondary", fontWeight: 400 }}>
                    {token.symbol}
                  </Box>
                </Typography>
                <Typography variant="body2" sx={{ color: "text.secondary", wordBreak: "break-all" }}>
                  {token.address}
                </Typography>
              </Box>
            </Box>
            <Alert severity="warning">
              This token is not on any token list KoinDX supports. Anyone can create a token, including copies of
              existing ones, so check the contract address before you trade.
            </Alert>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              The token contract needs to implement allowances.
            </Typography>
            <Button fullWidth size="large" onClick={importToken} variant="contained">
              Import
            </Button>
          </Box>
        ) : null}
      </Box>
    </Modal>
  );
};

export default ModalImportToken;
